var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.carregado)?_c('GrupoFamiliar',{attrs:{"idFuncionalidade":_vm.idFuncionalidade},on:{"click":_vm.proximo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }